import BaseModelInstance from './base.model'
import { Message as ModelDefinition } from './model-definitions'

class Message extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default Message
